import * as d3 from 'd3'

export default {
  methods: {

    draw_Forms() {

      this.canvasForms = this.svg
      .append('g')
      .attr('transform', `translate(0.5, 0.5)`)
      .style('font-family', 'roboto').attr('cursor', 'default')

      this.canvasForms
      .append('text')
      .attr('x', 30).attr('y', 40)
      .attr('font-size', 30).attr('fill', '#44A9DF').attr('font-weight', 400)
      .text(this.header.main)

      this.canvasForms
      .append('text')
      .attr('x', 32).attr('y', 57)
      .attr('font-size', 13).attr('fill', '#757575')
      .text(this.header.sub)
      
      
      this.draw_Header()
      this.draw_Timeline()
      this.draw_Table()
      this.draw_Gantt()
      this.draw_Legend()

    },

  }
}